import type { CSSProperties } from 'react';

/** 课程详情页面常量与配置 */

export const SEM_LABEL: Record<string, string> = {
  semester1: '第一学期',
  semester2: '第二学期',
  winter: '寒假',
  summer: '暑假',
};

export const SEM_COLOR: Record<string, string> = {
  semester1: 'blue',
  semester2: 'geekblue',
  winter: 'cyan',
  summer: 'orange',
};

export const GRADE_MAP: Record<string, string> = {
  '1': '小一', '2': '小二', '3': '小三', '4': '小四', '5': '小五', '6': '小六',
  '7': '初一', '8': '初二', '9': '初三',
  '10': '高一', '11': '高二', '12': '高三',
};

export const WEEK_DAYS = [
  { label: '周一', value: 0 },
  { label: '周二', value: 1 },
  { label: '周三', value: 2 },
  { label: '周四', value: 3 },
  { label: '周五', value: 4 },
  { label: '周六', value: 5 },
  { label: '周日', value: 6 },
];

export const ATTENDANCE_STATUS = [
  { label: '出勤', value: 'present', color: 'green' },
  { label: '缺勤', value: 'absent', color: 'red' },
  { label: '迟到', value: 'late', color: 'orange' },
  { label: '请假', value: 'leave', color: 'blue' },
];

export const ATTENDANCE_COLOR: Record<string, string> = {
  present: 'green',
  absent: 'red',
  late: 'orange',
  leave: 'blue',
};

export const ATTENDANCE_LABEL: Record<string, string> = {
  present: '出勤',
  absent: '缺勤',
  late: '迟到',
  leave: '请假',
};

export const PERFORMANCE_OPTIONS = [
  { label: '优秀', value: 'excellent', color: 'gold' },
  { label: '良好', value: 'good', color: 'green' },
  { label: '达标', value: 'pass', color: 'blue' },
  { label: '待达标', value: 'fail', color: 'red' },
];

export const PERFORMANCE_COLOR: Record<string, string> = {
  excellent: 'gold',
  good: 'green',
  pass: 'blue',
  fail: 'red',
};

export const PERFORMANCE_LABEL: Record<string, string> = {
  excellent: '优秀',
  good: '良好',
  pass: '达标',
  fail: '待达标',
};

export const HOMEWORK_TYPE_OPTIONS = [
  { label: '练习', value: 'practice' },
  { label: '实验', value: 'experiment' },
  { label: '报告', value: 'report' },
  { label: '其他', value: 'other' },
];

export const HOMEWORK_TYPE_COLOR: Record<string, string> = {
  practice: 'blue',
  experiment: 'purple',
  report: 'green',
  other: 'default',
};

export const GRADE_OPTIONS = [
  { label: '优', value: 'excellent', color: 'gold' },
  { label: '良', value: 'good', color: 'green' },
  { label: '达标', value: 'satisfactory', color: 'blue' },
  { label: '待达标', value: 'unsatisfactory', color: 'red' },
];

export const GRADE_COLOR: Record<string, string> = {
  excellent: 'gold',
  good: 'green',
  satisfactory: 'blue',
  unsatisfactory: 'red',
};

export const GRADE_LABEL: Record<string, string> = {
  excellent: '优',
  good: '良',
  satisfactory: '达标',
  unsatisfactory: '待达标',
};

/** 课程状态展示（「已结束」用淡红色背景标识，全站统一） */
export const COURSE_STATUS_STYLE: Record<string, { label: string; tagColor: string; style?: CSSProperties }> = {
  not_started: { label: '未开始', tagColor: 'default' },
  ongoing: { label: '进行中', tagColor: 'processing' },
  ended: {
    label: '已结束',
    tagColor: 'red',
    style: { background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' },
  },
};

/** 是否开设（is_active）对应的展示 */
export const COURSE_ACTIVE_STYLE = {
  active: { label: '开设中', tagColor: 'green', style: { background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' } as CSSProperties },
  ended: COURSE_STATUS_STYLE.ended,
};
